import Card from "@material-ui/core/Card";
import { CustomFieldsList } from "components/CustomFields";
import { DocumentTemplateList } from "components/DocumentTemplates";
import { ProductArticlesList } from "components/ProductArticles";
import { AppReferenceManyField } from "components/list/AppReferenceManyField";
import React from "react";
import {
	Edit,
	SimpleForm,
	Tab,
	TabbedShowLayout,
} from "react-admin";

import { SaveWithCancelToolbar } from "../../../components/toolbars/SaveWithCancelToolbar";
import { AppRoles, UserRole } from "../../../entities/";
import {
	CompanyServiceSettingsTab,
	CompanySettingsTab,
	Notifications,
} from "../../../pages/settings/";
import { isInArray } from "../../../utils/general";
import { CustomerCompaniesMappersList } from "../CustomerCompaniesMappers/CustomerCompaniesMappersList";
import { CustomerCompanyEditForm } from "./EditForm";

export const CompanyEdit = (props) => {
	const isAdminAppManager = props.permissions && isInArray(AppRoles, props.permissions.role);

	return isAdminAppManager ? (
		<TabbedShowLayout
			style={{ paddingBottom: 8 }}
			basePath={props.basePath}
			syncWithLocation={true}
		>
			<Tab label="tab.geneneral.name">
				<Edit {...props} undoable={false}>
					<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />}>
						<CustomerCompanyEditForm />
					</SimpleForm>
				</Edit>
			</Tab>
			<Tab label="tab.notifications.name">
				<Edit {...props} undoable={false} actions={null}>
					<Notifications {...props} />
				</Edit>
			</Tab>
			<Tab label="tab.settings.name">
				<Edit {...props} undoable={true} actions={null}>
					<CompanySettingsTab {...props} />
				</Edit>
			</Tab>
			<Tab label="tab.service-settings.name">
				<Edit {...props} undoable={true} actions={null}>
					<CompanyServiceSettingsTab {...props} />
				</Edit>
			</Tab>
			<Tab label="tab.mapper.name" path="mappers">
				<Card>
					<AppReferenceManyField
						label={false}
						fullWidth
						reference="mappers"
						filter={{ company_id: props.id }}
					>
						<CustomerCompaniesMappersList {...props} />
					</AppReferenceManyField>
				</Card>
			</Tab>
			<Tab label="tab.document-template.name" path="document-templates">
				<Card>
					<AppReferenceManyField
						label={false}
						fullWidth
						reference="document-templates"
						filter={{ company_id: props.id }}
					>
						<DocumentTemplateList {...props} />
					</AppReferenceManyField>
				</Card>
			</Tab>
			<Tab label="tab.custom-field.name" path="custom-fields">
				<Card>
					<AppReferenceManyField
						label={false}
						fullWidth
						reference="custom-fields"
						filter={{ company_id: props.id }}
					>
						<CustomFieldsList companyId={props.id} {...props} />
					</AppReferenceManyField>
				</Card>
			</Tab>
			<Tab label="tab.product-articles.name" path="product-articles">
				<Card>
					<ProductArticlesList companyId={props.id} {...props} resource="product-articles" />
				</Card>
			</Tab>

		</TabbedShowLayout>
	) : (
		<Edit {...props} undoable={false}>
			<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />}>
				<CustomerCompanyEditForm />
			</SimpleForm>
		</Edit>
	);
};
